import actions from './actions';

export const closeModal = () => {
  return { type: actions.CLOSE_MODAL };
}

export const openModal = () => {
  return { type: actions.OPEN_MODAL };
}
